(() => {
  function resolveQuantity(value) {
    const quantity = Math.floor(Number(value));
    return quantity > 0 ? quantity : 1;
  }

  function resolvePriceView(data) {
    const price = Number(data.price || 0);
    const compareAtPrice = Number(data.compareAtPrice || 0);
    const onSale = compareAtPrice > price;
    return {
      price: data.formattedPrice || '',
      compareAtPrice: onSale ? data.formattedCompareAtPrice || '' : '',
      onSale,
    };
  }

  function resolveBuyNowUrl(variantId, quantity, root = '/') {
    const id = String(variantId || '').trim();
    if (!/^\d+$/.test(id)) return '';
    const base = String(root || '/');
    const normalizedRoot = base.endsWith('/') ? base : `${base}/`;
    return `${normalizedRoot}cart/${id}:${resolveQuantity(quantity)}`;
  }

  function updatePriceContainer(price, view) {
    if (!price) return;
    const regular = price.querySelector('.price__regular');
    const sale = price.querySelector('.price__sale');
    const regularValue = regular && regular.querySelector('.price-item--last');
    const saleValue = sale && sale.querySelector('.price-item--last');
    const compareValue = sale && sale.querySelector('s.price-item--regular');

    if (regularValue) regularValue.textContent = view.price;
    if (saleValue) saleValue.textContent = view.price;
    if (compareValue) compareValue.textContent = view.compareAtPrice;

    if (regular) {
      regular.classList.toggle('d-none', view.onSale);
      regular.classList.toggle('d-block', !view.onSale);
    }
    if (sale) {
      sale.classList.toggle('d-none', !view.onSale);
      sale.classList.toggle('d-flex', view.onSale);
    }
  }

  function updateProductPrice(section, view) {
    updatePriceContainer(section.querySelector('.js-product-price .price'), view);
  }

  function updateStickyPrice(sectionId, view) {
    const stickyPrice = document.querySelector(`#productStickyInfo-${sectionId} .js-product-sticky-info-price .price`);
    updatePriceContainer(stickyPrice, view);
  }

  const BaseHTMLElement = typeof HTMLElement === 'undefined' ? class {} : HTMLElement;

  class HolidaySocksOfferSelector extends BaseHTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.section = this.closest('.js-main-product');
      if (!this.section) return;

      this.dataset.initialized = 'true';
      this.mainSectionId = this.section.id;
      this.submitButton = this.querySelector('[data-holiday-socks-submit]');
      this.buyNowButton = this.querySelector('[data-holiday-socks-buy-now]');
      this.errorMessage = this.querySelector('[data-holiday-socks-error]');
      this.singleRadio = this.querySelector('input[name="holiday_socks_option"][value="single"]');
      this.stickyRoot = document.querySelector(`#productStickyInfo-${this.mainSectionId}`);
      this.stickyButton = this.stickyRoot && this.stickyRoot.querySelector('[type="submit"]');

      if (!this.submitButton || !this.buyNowButton) return;

      this.section.classList.add('holiday-bundle-enabled');
      this.addEventListener('change', this.handleChange.bind(this));
      this.submitButton.addEventListener('click', () => this.addToCart());
      this.buyNowButton.addEventListener('click', () => {
        if (this.buyNowButton.disabled) return;
        const checkoutUrl = resolveBuyNowUrl(this.dataset.variantId, this.selectedQuantity(), this.routesRoot());
        if (checkoutUrl) window.location.assign(checkoutUrl);
      });
      // The Pumper app takes over product form submits and adds its own tier selection, so the sticky bar
      // is stopped before its form submits and adds through this selector instead.
      if (this.stickyRoot) {
        this.handleStickyClick = this.handleStickyClick.bind(this);
        this.stickyRoot.addEventListener('click', this.handleStickyClick, { capture: true });
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.dataset.initialized === 'true') this.restoreState();
    }

    restoreState() {
      if (!this.section) return;
      this.section.classList.remove('holiday-bundle-enabled');
      if (this.stickyRoot && this.handleStickyClick) {
        this.stickyRoot.removeEventListener('click', this.handleStickyClick, { capture: true });
      }
      if (this.singleRadio) {
        const singlePriceView = resolvePriceView(this.singleRadio.dataset);
        updateProductPrice(this.section, singlePriceView);
        updateStickyPrice(this.mainSectionId, singlePriceView);
      }
    }

    routesRoot() {
      return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    }

    checkedRadio() {
      return this.querySelector('input[name="holiday_socks_option"]:checked');
    }

    selectedQuantity() {
      const checked = this.checkedRadio();
      return resolveQuantity(checked && checked.dataset.quantity);
    }

    handleStickyClick(event) {
      if (!event.target.closest('[type="submit"]')) return;
      event.preventDefault();
      event.stopPropagation();
      this.addToCart();
    }

    showError(message) {
      if (!this.errorMessage) return;
      this.errorMessage.textContent = message || '';
      this.errorMessage.hidden = !message;
    }

    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', busy ? 'true' : 'false');
      this.update();
    }

    // UpCart watches /cart/add.js and opens its drawer; without it, send the shopper to the cart page.
    async addToCart() {
      if (this.busy || this.submitButton.disabled) return;
      const root = this.routesRoot();
      const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
      this.showError('');
      this.setBusy(true);
      try {
        const response = await fetch(`${normalizedRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: this.selectedQuantity() }] }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          this.showError(data.description || data.message || this.dataset.errorMessage);
          return;
        }
        const upcart = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
        if (!upcart || !upcart.cartIsEnabled) window.location.assign(`${normalizedRoot}cart`);
      } catch (error) {
        this.showError(this.dataset.errorMessage);
      } finally {
        this.setBusy(false);
      }
    }

    handleChange(event) {
      if (!event.target.matches('input[name="holiday_socks_option"]')) return;
      this.showError('');
      this.update();
    }

    update() {
      const checked = this.checkedRadio();
      if (!checked) return;
      const available = checked.dataset.available === 'true';
      const enabled = available && !this.busy;
      this.submitButton.disabled = !enabled;
      this.submitButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      this.buyNowButton.disabled = !enabled;
      this.buyNowButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      if (this.stickyButton) {
        this.stickyButton.disabled = !enabled;
        this.stickyButton.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      }
      this.submitButton.textContent = checked.dataset.buttonLabel;
      if (this.stickyButton) {
        const stickyLabel = this.stickyButton.querySelector('.js-product-form-submit-btn-text');
        if (stickyLabel) stickyLabel.textContent = this.submitButton.textContent;
      }
      const priceView = resolvePriceView(checked.dataset);
      updateProductPrice(this.section, priceView);
      updateStickyPrice(this.mainSectionId, priceView);
      this.dispatchEvent(new CustomEvent('holiday-socks:change', {
        bubbles: true,
        detail: { key: checked.value, quantity: this.selectedQuantity(), available },
      }));
    }
  }

  class HolidaySocksOfferSelectorMount extends BaseHTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.template = this.querySelector('template');
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
      this.mountSelector();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
      this.removeMountedSelector();
    }

    removeMountedSelector() {
      document.querySelectorAll('[data-holiday-socks-selector-owner]').forEach((selector) => {
        if (selector.dataset.holidaySocksSelectorOwner === this.dataset.ownerId) selector.remove();
      });
    }

    mountSelector() {
      if (!this.template) return;
      const mainSection = document.querySelector('.js-main-product');
      const buyButtons = mainSection && mainSection.querySelector('.product__block-buy_buttons');
      const source = this.template.content.querySelector('holiday-socks-offer-selector');
      if (!buyButtons || !source) return;
      this.removeMountedSelector();
      const selector = source.cloneNode(true);
      selector.dataset.holidaySocksSelectorOwner = this.dataset.ownerId;
      buyButtons.before(selector);
    }

    handleSectionLoad(event) {
      const loadedSection = event.target;
      if (loadedSection.matches('.js-main-product') || loadedSection.querySelector('.js-main-product')) {
        queueMicrotask(() => this.mountSelector());
      }
    }
  }

  if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('holiday-socks-offer-selector-mount')) {
    window.customElements.define('holiday-socks-offer-selector-mount', HolidaySocksOfferSelectorMount);
  }

  if (typeof window !== 'undefined' && window.customElements && !window.customElements.get('holiday-socks-offer-selector')) {
    window.customElements.define('holiday-socks-offer-selector', HolidaySocksOfferSelector);
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { resolveQuantity, resolvePriceView, resolveBuyNowUrl };
  }
})();
